

function Supporto() {
    const handleDownloadClick = () => {
        console.log("scarica")
    }

    return (
        <div className="flex flex-col items-center justify-center gap-4 text-white h-screen">
            <div>Clicca qui! ↴</div>
            
            <a href="/Assistenza-Careisgold.exe" target="_blank" download="AssistenzaCareigold.exe" onClick={handleDownloadClick} className="w-fit px-8 py-4 border border-white text-white hover:underline">
                Scarica
            </a>
        </div>
    )
}

export default Supporto;